import {Tabs} from "antd"
import {useTranslation} from "react-i18next"
import {useActiveTab} from "hooks"
import {TabHeader} from "components/Tab"
import {SapAlert} from "sections/academics/sap/SapAlert"
import {SapAction} from "sections/academics/sap/SapAction"
import SapChecksList from "sections/academics/registrar/Sap/parts/SapChecksList"

const {TabPane} = Tabs

const SAP_TABS = {
    ALERTS: "alerts",
    ACTIONS: "actions",
    CHECKS: "checks"
}

type Props = {
    studentId: number
    departmentId: number
}

export function SAP(props: Props) {
    const {studentId, departmentId} = props
    const {t} = useTranslation(["academics"])
    const [activeTab, onChangeTab] = useActiveTab(SAP_TABS.CHECKS, "saptype")

    const onSwitchTabPane = (activeKey?: string) => {
        onChangeTab(activeKey)
    }

    return (
        <Tabs className="fullwidth klassSubTab" activeKey={activeTab} onChange={onSwitchTabPane}>
            <TabPane key={SAP_TABS.CHECKS} tab={<TabHeader title={t("academics.sapChecks.tab")} />}>
                {activeTab === SAP_TABS.CHECKS && <SapChecksList studentProfileId={studentId} />}
            </TabPane>
            <TabPane key={SAP_TABS.ALERTS} tab={<TabHeader title="Alerts" />}>
                {activeTab === SAP_TABS.ALERTS && <SapAlert studentId={studentId} departmentId={departmentId} />}
            </TabPane>
            <TabPane key={SAP_TABS.ACTIONS} tab={<TabHeader title="Actions" />}>
                {activeTab === SAP_TABS.ACTIONS && <SapAction studentId={studentId} departmentId={departmentId} />}
            </TabPane>
        </Tabs>
    )
}
